import { SessionStorageType } from './tracking/session-storage';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CookieName } from '../constants/product-domain';
import { createAppState } from '../state/app';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie/src/cookie.service";
import * as i2 from "./windowRef.service";
import * as i3 from "@angular/common/http";
import * as i4 from "./environment.service";
import * as i5 from "../state/app/app.service";
export class UtilityService {
    constructor(cookieService, windowService, http, env, appService) {
        this.cookieService = cookieService;
        this.windowService = windowService;
        this.http = http;
        this.env = env;
        this.appService = appService;
        this.isUSCustomer = null;
    }
    getGeolocationData() {
        const url = this.env.getGeoLocationUrl();
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            accept: 'application/json',
        });
        return this.http.get(url, { headers });
    }
    requestIsUSCustomer() {
        return this.getGeolocationData().pipe(map((response) => {
            if (response !== null) {
                this.isUSCustomer = response.country_code.toLowerCase() === 'us';
            }
            else {
                // If the response is null (likely because lower environments return a blank response)
                // assume the customer is a US customer and proceed to the gsuite page
                this.isUSCustomer = true;
            }
            return this.isUSCustomer;
        }));
    }
    getExpiryDate(days) {
        const currentDate = new Date();
        currentDate.setTime(currentDate.getTime() + (1000 * 60 * 60 * 24 * days)); // adds days in milliseconds
        return currentDate.toUTCString();
    }
    setApprovedCookie(cookieType, name, value, storeUnencoded = false, expirationInDays = 365) {
        const nativeWin = this.windowService.nativeWindow;
        const approvedCookieCats = nativeWin.OptanonActiveGroups ? nativeWin.OptanonActiveGroups.split(',') : ['C0001'];
        const cookieDomain = this.windowService.nativeWindow.location.hostname === 'localhost' ? 'localhost' : 'legalzoom.com';
        const cookieOptions = { domain: cookieDomain, expires: this.getExpiryDate(expirationInDays), storeUnencoded };
        if (approvedCookieCats.indexOf(cookieType) !== -1) {
            this.cookieService.put(name, value, cookieOptions);
        }
    }
    getStringParamFromQueryString(paramName) {
        return this.getParamValueQueryString(paramName) ? this.getParamValueQueryString(paramName) : undefined;
    }
    getIntParamFromQueryString(paramName) {
        return (this.getParamValueQueryString(paramName) &&
            parseInt(this.getParamValueQueryString(paramName), 10)) ?
            Number(this.getParamValueQueryString(paramName)) : undefined;
    }
    getParamValueQueryString(paramName) {
        const url = window.location.href;
        let paramValue;
        if (url.includes('?')) {
            const httpParams = new HttpParams({ fromString: url.split('?')[1] });
            paramValue = httpParams.get(paramName);
        }
        return paramValue;
    }
    clearCookies() {
        const cookieDomain = this.windowService.nativeWindow.location.hostname === 'localhost' ? 'localhost' : 'legalzoom.com';
        const cookieOptions = { domain: cookieDomain };
        this.cookieService.remove(CookieName.LZAuthCookie, cookieOptions);
        this.cookieService.remove(CookieName.USERIDENTIFICATION, cookieOptions);
        this.cookieService.remove(CookieName.TIMESTRING1, cookieOptions);
    }
    clearAppState(removeCookies) {
        if (removeCookies) {
            this.clearCookies();
        }
        this.windowService.nativeWindow.sessionStorage.removeItem(SessionStorageType.APP);
        this.appService.app = createAppState({});
    }
    getAuthTokenConsultationCookie() {
        const userIdCookieValue = this.cookieService.get(CookieName.USERIDENTIFICATION);
        let authToken = '';
        if (userIdCookieValue) {
            const userIdCookieValues = userIdCookieValue.split('&');
            userIdCookieValues.forEach((value) => {
                if (value.startsWith('consultation_id=')) {
                    authToken = value.replace('consultation_id=', '');
                }
            });
        }
        return authToken;
    }
    getCustomerIdConsultationCookie() {
        const userIdCookieValue = this.cookieService.get(CookieName.USERIDENTIFICATION);
        let customerId = 0;
        if (userIdCookieValue) {
            const userIdCookieValues = userIdCookieValue.split('&');
            userIdCookieValues.forEach((value) => {
                if (value.startsWith('cid=')) {
                    customerId = +value.replace('cid=', '');
                }
            });
        }
        return customerId;
    }
}
UtilityService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilityService_Factory() { return new UtilityService(i0.ɵɵinject(i1.CookieService), i0.ɵɵinject(i2.WindowRef), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.EnvironmentService), i0.ɵɵinject(i5.AppService)); }, token: UtilityService, providedIn: "root" });
